const IntroPopUpActionTypes = {
  SET_INTRO_POPUP: 'SET_INTRO_POPUP',
};

export default IntroPopUpActionTypes;
